export const OLD_APM_DIRTY_PORTFOLIO_RESPONSE_2 = {
	success: true,
	errors: [
		{
			code: 'MODEL_IS_OVERRIDDEN_AT_BLK',
			message: 'no',
			details: 'The model is imported in BLK'
		},
		{
			code: 'MODEL_IS_MODIFIED_AT_SOURCE',
			message: 'no',
			details: 'The model has been modified at source since its last import'
		},
		{
			code: 'MODEL_IS_A_FIRST_TIME_IMPORT',
			message: 'no',
			details: 'The model is imported for first time '
		}
	],
	status: 'OK',
	response: {
		id: '49c05b8c-534d-41f2-869d-09ca165a26f3',
		description: 'ENV Model with unsupported',
		type: 'PORTFOLIO',
		subType: 'THIRD_PARTY_MODEL',
		children: [
			{
				identifier: 'CASH-USD@XUSD00000@',
				identifierType: 'SECURITY_ID',
				weight: 2.0,
				allData: {
					date: 1579126448697,
					positionType: 'VALID',
					'@type': '_bws.user.WebUserData',
					identifierType: 'SECURITY_ID',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					dateCreated: 1579126448697,
					dateLastModified: 1579126448697,
					userEmail: 'lyonsma@bfm.com',
					commonIdentifier: 'CASH-USD@XUSD00000@',
					owner: {
						userPlatformId: '3225276',
						userEmail: 'lyonsma@bfm.com',
						userBuyingUnitId: '2341111',
						userId: 'lyonsma@bfm.com',
						userClientId: '36423191585181741585'
					},
					identifier: 'CASH-USD@XUSD00000@',
					trackingType: 'userData',
					userPlatformId: '3225276',
					childFlag: true,
					level: 1,
					updateUserId: 'lyonsma@bfm.com',
					weight: 2,
					userId: 'lyonsma@bfm.com',
					updateTimestamp: 1579126458758,
					parentId: '49c05b8c-534d-41f2-869d-09ca165a26f3',
					parentType: 'PORTFOLIO',
					userClientId: '36423191585181741585',
					commonIdentifierType: 'SECURITY_ID',
					otherIdentifiers: [
						{
							identifier: '0100000AENM01154570HKFD6S4KYWEUMIWHJOR24RW4IDVLGNMR2CYMEZAZ6VKBDFSZBWELQ====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						},
						{
							identifier: 'CASH-USD',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						},
						{
							identifier: 'CASH-USD',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSIP'
						}
					],
					originPlatform: { name: 'Cash', type: 'SECURITY' },
					userBuyingUnitId: '2341111',
					userTrackingId: '2555941',
					uniqueId: '0d566582-309c-4b2f-9ae7-9a1591d33d85'
				}
			},
			{
				identifier: 'AGG@464287226@US4642872265',
				identifierType: 'SECURITY_ID',
				weight: 15.0,
				allData: {
					date: 1579126448697,
					positionType: 'VALID',
					'@type': '_bws.user.WebUserData',
					identifierType: 'SECURITY_ID',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					dateCreated: 1579126448697,
					dateLastModified: 1579126448697,
					userEmail: 'lyonsma@bfm.com',
					commonIdentifier: 'AGG@464287226@US4642872265',
					owner: {
						userPlatformId: '3225276',
						userEmail: 'lyonsma@bfm.com',
						userBuyingUnitId: '2341111',
						userId: 'lyonsma@bfm.com',
						userClientId: '36423191585181741585'
					},
					identifier: 'AGG@464287226@US4642872265',
					trackingType: 'userData',
					userPlatformId: '3225276',
					childFlag: true,
					level: 1,
					updateUserId: 'lyonsma@bfm.com',
					weight: 15,
					userId: 'lyonsma@bfm.com',
					updateTimestamp: 1579126458758,
					parentId: '49c05b8c-534d-41f2-869d-09ca165a26f3',
					parentType: 'PORTFOLIO',
					userClientId: '36423191585181741585',
					commonIdentifierType: 'SECURITY_ID',
					otherIdentifiers: [
						{
							identifier: '0100000AEEN01114905HGK3WGDXZP7NJFE5XHVRNWEPEVQ6BZLPTN4KTLCOSFF76AOPQCAOA====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						},
						{
							identifier: 'AGG',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						},
						{
							identifier: '464287226',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSIP'
						}
					],
					originPlatform: {
						name: 'iShares Core US Aggregate Bond',
						type: 'SECURITY'
					},
					userBuyingUnitId: '2341111',
					userTrackingId: '2555941',
					uniqueId: '32b9e257-8978-4289-ade6-26042cac770b'
				}
			},
			{
				identifier: 'USIG@464288620@US4642886208',
				identifierType: 'SECURITY_ID',
				weight: 5.0,
				allData: {
					date: 1579126448697,
					positionType: 'SUBSTITUTED',
					'@type': '_bws.user.WebUserData',
					identifierType: 'SECURITY_ID',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					mappedFrom: [
						'ENVESTNET_HANDLE@0100000AEEN0111304668HKP2ZEEWKV6VJQDOTZJPXV4L6A56SNGHIOQ26KONHDMKIHD6ANX6A===='
					],
					dateCreated: 1579126448697,
					dateLastModified: 1579126448697,
					userEmail: 'lyonsma@bfm.com',
					commonIdentifier: 'USIG@464288620@US4642886208',
					owner: {
						userPlatformId: '3225276',
						userEmail: 'lyonsma@bfm.com',
						userBuyingUnitId: '2341111',
						userId: 'lyonsma@bfm.com',
						userClientId: '36423191585181741585'
					},
					identifier: 'USIG@464288620@US4642886208',
					trackingType: 'userData',
					userPlatformId: '3225276',
					childFlag: true,
					level: 1,
					updateUserId: 'lyonsma@bfm.com',
					weight: 5,
					userId: 'lyonsma@bfm.com',
					updateTimestamp: 1579126458758,
					parentId: '49c05b8c-534d-41f2-869d-09ca165a26f3',
					parentType: 'PORTFOLIO',
					userClientId: '36423191585181741585',
					commonIdentifierType: 'SECURITY_ID',
					userBuyingUnitId: '2341111',
					userTrackingId: '2555941',
					uniqueId: '3d2ec631-0913-4d6e-8792-3a4c9cd39924'
				}
			},
			{
				identifier: 'ITOT@464287150@US4642871507',
				identifierType: 'SECURITY_ID',
				weight: 20.0,
				allData: {
					date: 1579126448697,
					positionType: 'VALID',
					'@type': '_bws.user.WebUserData',
					identifierType: 'SECURITY_ID',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					dateCreated: 1579126448697,
					dateLastModified: 1579126448697,
					userEmail: 'lyonsma@bfm.com',
					commonIdentifier: 'ITOT@464287150@US4642871507',
					owner: {
						userPlatformId: '3225276',
						userEmail: 'lyonsma@bfm.com',
						userBuyingUnitId: '2341111',
						userId: 'lyonsma@bfm.com',
						userClientId: '36423191585181741585'
					},
					identifier: 'ITOT@464287150@US4642871507',
					trackingType: 'userData',
					userPlatformId: '3225276',
					childFlag: true,
					level: 1,
					updateUserId: 'lyonsma@bfm.com',
					weight: 20,
					userId: 'lyonsma@bfm.com',
					updateTimestamp: 1579126458758,
					parentId: '49c05b8c-534d-41f2-869d-09ca165a26f3',
					parentType: 'PORTFOLIO',
					userClientId: '36423191585181741585',
					commonIdentifierType: 'SECURITY_ID',
					otherIdentifiers: [
						{
							identifier: '464287150',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSIP'
						},
						{
							identifier: 'ITOT',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						},
						{
							identifier: '0100000AEEN01115324HGU6WTTIQ5ZG46U46UTAC6UBAMYCIB3HZKZGQRYGSOZRBZIVROGYA====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						}
					],
					originPlatform: {
						name: 'iShares Core S&P Total US Stock Mkt ETF',
						type: 'SECURITY'
					},
					userBuyingUnitId: '2341111',
					userTrackingId: '2555941',
					uniqueId: 'a8a2dea4-45eb-4722-a07f-9793969cda28'
				}
			},
			{
				identifier: 'VO@922908629@US9229086296',
				identifierType: 'SECURITY_ID',
				weight: 4.0,
				allData: {
					date: 1579126448697,
					positionType: 'VALID',
					'@type': '_bws.user.WebUserData',
					identifierType: 'SECURITY_ID',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					dateCreated: 1579126448697,
					dateLastModified: 1579126448697,
					userEmail: 'lyonsma@bfm.com',
					commonIdentifier: 'VO@922908629@US9229086296',
					owner: {
						userPlatformId: '3225276',
						userEmail: 'lyonsma@bfm.com',
						userBuyingUnitId: '2341111',
						userId: 'lyonsma@bfm.com',
						userClientId: '36423191585181741585'
					},
					identifier: 'VO@922908629@US9229086296',
					trackingType: 'userData',
					userPlatformId: '3225276',
					childFlag: true,
					level: 1,
					updateUserId: 'lyonsma@bfm.com',
					weight: 4,
					userId: 'lyonsma@bfm.com',
					updateTimestamp: 1579126458757,
					parentId: '49c05b8c-534d-41f2-869d-09ca165a26f3',
					parentType: 'PORTFOLIO',
					userClientId: '36423191585181741585',
					commonIdentifierType: 'SECURITY_ID',
					otherIdentifiers: [
						{
							identifier: 'VO',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						},
						{
							identifier: '922908629',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSIP'
						},
						{
							identifier: '0100000AEEN011721HPTUO5N52IPHVBA36GDVOUW3FRH5UMELB7AFN4LJTFDYOGUNT566A====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						}
					],
					originPlatform: {
						name: 'Vanguard Mid-Cap ETF',
						type: 'SECURITY'
					},
					userBuyingUnitId: '2341111',
					userTrackingId: '2555941',
					uniqueId: '1879383c-8fc4-4eb4-a622-bf66b7d15d6c'
				}
			},
			{
				identifier: 'MAHQX@09252M883@US09252M8837',
				identifierType: 'SECURITY_ID',
				weight: 19.0,
				allData: {
					date: 1579126448697,
					positionType: 'VALID',
					'@type': '_bws.user.WebUserData',
					identifierType: 'SECURITY_ID',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					dateCreated: 1579126448697,
					dateLastModified: 1579126448697,
					userEmail: 'lyonsma@bfm.com',
					commonIdentifier: 'MAHQX@09252M883@US09252M8837',
					owner: {
						userPlatformId: '3225276',
						userEmail: 'lyonsma@bfm.com',
						userBuyingUnitId: '2341111',
						userId: 'lyonsma@bfm.com',
						userClientId: '36423191585181741585'
					},
					identifier: 'MAHQX@09252M883@US09252M8837',
					trackingType: 'userData',
					userPlatformId: '3225276',
					childFlag: true,
					level: 1,
					updateUserId: 'lyonsma@bfm.com',
					weight: 19,
					userId: 'lyonsma@bfm.com',
					updateTimestamp: 1579126458757,
					parentId: '49c05b8c-534d-41f2-869d-09ca165a26f3',
					parentType: 'PORTFOLIO',
					userClientId: '36423191585181741585',
					commonIdentifierType: 'SECURITY_ID',
					otherIdentifiers: [
						{
							identifier: 'MAHQX',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						},
						{
							identifier: '0100000AEEN01117698HGN6PYBDMYVMDMRHKK2SGW44QS3ULS2E6WG2EGPCS65SO4UF7FN6Q====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						},
						{
							identifier: '09252M883',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSIP'
						}
					],
					originPlatform: {
						name: 'BlackRock Total Return Instl',
						type: 'SECURITY'
					},
					userBuyingUnitId: '2341111',
					userTrackingId: '2555941',
					uniqueId: '230d8eba-0a42-49a7-b1db-07e546b3ff3a'
				}
			},
			{
				identifier: 'ENVESTNET_HANDLE@0100000AEEN0111304668HKP2ZEEWKV6VJQDOTZJPXV4L6A56SNGHIOQ26KONHDMKIHD6ANX6A====',
				identifierType: 'CUSTOM',
				weight: 5.0,
				allData: {
					date: 1579126448697,
					positionType: 'INVALID',
					'@type': '_bws.user.WebUserData',
					identifierType: 'CUSTOM',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					dateCreated: 1579126448697,
					dateLastModified: 1579126448697,
					userEmail: 'lyonsma@bfm.com',
					owner: {
						userPlatformId: '3225276',
						userEmail: 'lyonsma@bfm.com',
						userBuyingUnitId: '2341111',
						userId: 'lyonsma@bfm.com',
						userClientId: '36423191585181741585'
					},
					identifier: 'ENVESTNET_HANDLE@0100000AEEN0111304668HKP2ZEEWKV6VJQDOTZJPXV4L6A56SNGHIOQ26KONHDMKIHD6ANX6A====',
					trackingType: 'userData',
					userPlatformId: '3225276',
					childFlag: true,
					level: 1,
					updateUserId: 'lyonsma@bfm.com',
					weight: 5,
					userId: 'lyonsma@bfm.com',
					updateTimestamp: 1579126458757,
					parentId: '49c05b8c-534d-41f2-869d-09ca165a26f3',
					parentType: 'PORTFOLIO',
					userClientId: '36423191585181741585',
					otherIdentifiers: [
						{
							identifier: '94974BFY1',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						},
						{
							identifier: '0100000AEEN0111304668HKP2ZEEWKV6VJQDOTZJPXV4L6A56SNGHIOQ26KONHDMKIHD6ANX6A====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						},
						{
							identifier: '94974BFY1',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSIP'
						}
					],
					originPlatform: {
						name: 'Wells Fargo 4.100 06/03/26 MTN',
						type: 'FIXED_INCOME'
					},
					userBuyingUnitId: '2341111',
					userTrackingId: '2555941',
					uniqueId: '2b5dd2f7-3892-4503-bce9-fddf48a043c0'
				}
			},
			{
				identifier: 'TGBAX@880208400@US8802084009',
				identifierType: 'SECURITY_ID',
				weight: 15.0,
				allData: {
					date: 1579126448697,
					positionType: 'VALID',
					'@type': '_bws.user.WebUserData',
					identifierType: 'SECURITY_ID',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					dateCreated: 1579126448697,
					dateLastModified: 1579126448697,
					userEmail: 'lyonsma@bfm.com',
					commonIdentifier: 'TGBAX@880208400@US8802084009',
					owner: {
						userPlatformId: '3225276',
						userEmail: 'lyonsma@bfm.com',
						userBuyingUnitId: '2341111',
						userId: 'lyonsma@bfm.com',
						userClientId: '36423191585181741585'
					},
					identifier: 'TGBAX@880208400@US8802084009',
					trackingType: 'userData',
					userPlatformId: '3225276',
					childFlag: true,
					level: 1,
					updateUserId: 'lyonsma@bfm.com',
					weight: 15,
					userId: 'lyonsma@bfm.com',
					updateTimestamp: 1579126458757,
					parentId: '49c05b8c-534d-41f2-869d-09ca165a26f3',
					parentType: 'PORTFOLIO',
					userClientId: '36423191585181741585',
					commonIdentifierType: 'SECURITY_ID',
					otherIdentifiers: [
						{
							identifier: '0100000AEEN01122041HK2LGVDPSTU3PRSII3IKZ5SOIQCCLU67DXXXCTEZZKVF67LDUXXMQ====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						},
						{
							identifier: 'TGBAX',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						},
						{
							identifier: '880208400',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSIP'
						}
					],
					originPlatform: {
						name: 'Templeton Global Bond Adv',
						type: 'SECURITY'
					},
					userBuyingUnitId: '2341111',
					userTrackingId: '2555941',
					uniqueId: '95ea1f75-6b6a-467b-8fef-6ce4b6ff818f'
				}
			},
			{
				identifier: 'LDLFX@543916464@US5439164642',
				identifierType: 'SECURITY_ID',
				weight: 20.0,
				allData: {
					date: 1579126448697,
					positionType: 'VALID',
					'@type': '_bws.user.WebUserData',
					identifierType: 'SECURITY_ID',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					dateCreated: 1579126448697,
					dateLastModified: 1579126448697,
					userEmail: 'lyonsma@bfm.com',
					commonIdentifier: 'LDLFX@543916464@US5439164642',
					owner: {
						userPlatformId: '3225276',
						userEmail: 'lyonsma@bfm.com',
						userBuyingUnitId: '2341111',
						userId: 'lyonsma@bfm.com',
						userClientId: '36423191585181741585'
					},
					identifier: 'LDLFX@543916464@US5439164642',
					trackingType: 'userData',
					userPlatformId: '3225276',
					childFlag: true,
					level: 1,
					updateUserId: 'lyonsma@bfm.com',
					weight: 20,
					userId: 'lyonsma@bfm.com',
					updateTimestamp: 1579126458757,
					parentId: '49c05b8c-534d-41f2-869d-09ca165a26f3',
					parentType: 'PORTFOLIO',
					userClientId: '36423191585181741585',
					commonIdentifierType: 'SECURITY_ID',
					otherIdentifiers: [
						{
							identifier: '0100000AEEN011201130HLENSSL5ILBY4643LJKLP2BJEPW4NP4Z52J3JWC2RMGDQF54I3QIQ====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						},
						{
							identifier: '543916464',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSIP'
						},
						{
							identifier: 'LDLFX',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						}
					],
					originPlatform: {
						name: 'Lord Abbett Short Duration Income F',
						type: 'SECURITY'
					},
					userBuyingUnitId: '2341111',
					userTrackingId: '2555941',
					uniqueId: 'c99cc7bc-e6f9-485b-a36a-f49696c54c67'
				}
			}
		],
		allData: {
			date: 1559327209638,
			'@type': 'com.bfm.webtools.api.domain.user.WebUserData',
			origin: 'partner',
			flags: {
				originContainsEditableModel: true,
				originContainsReallocatedSecurities: false,
				inputWithValues: false,
				originContainsFlattenedSleeves: false,
				isProcessed: true,
				originContainsUnmatchedSecurities: false,
				originContainsFixedIncomeSubstitutions: true,
				originContainsAssetClassSubstitutions: false
			},
			description: 'ENV Model with unsupported',
			type: 'PORTFOLIO',
			currentUserIsOwner: true,
			score: 1,
			parentFlag: true,
			dateCreated: 1559327209638,
			dateLastModified: 1579126458512,
			userEmail: 'lyonsma@bfm.com',
			perms: {
				DELETE: ['webUserDataPerm@AdvisorPort'],
				SHARE: ['webUserDataPerm@AdvisorPort'],
				VIEW: ['webUserDataPerm@AdvisorPort']
			},
			owner: {
				userPlatformId: '3225276',
				userEmail: 'lyonsma@bfm.com',
				userId: 'lyonsma@bfm.com'
			},
			ssoIdp: 'envestnet',
			toolOrigin: 'partner',
			trackingType: 'userData',
			userPlatformId: '3225276',
			level: 0,
			updateUserId: 'lyonsma@bfm.com',
			childCount: 9,
			userId: 'lyonsma@bfm.com',
			updateTimestamp: 1579126458758,
			otherIdentifiers: [
				{
					identifier: '49c05b8c-534d-41f2-869d-09ca165a26f3',
					customIdentifierType: 'ENVESTNET_HANDLE',
					'@type': '_bws.investments.IdentifierParam',
					identifierType: 'CUSTOM'
				}
			],
			subType: 'THIRD_PARTY_MODEL',
			originPlatform: {
				firm: 'demof',
				dateImported: '1559327209515',
				programHandle: '0100000AEEN01613H3MJAZEPFRG6GLHUIJ76FX664I5JKQH6OH6I5XGYWSI3Z6KJBLQLA====',
				externalModelDateLastModified: '1579126406233',
				riskHandle: '0100000AOOP03320HXOOOM2GK72BTE3FUJEPOEZVUWZZCGO2LVNTG77RQNTU5YAYCRSZA====',
				platform: 'ENVESTNET'
			},
			userTrackingId: '2555941',
			uniqueId: '49c05b8c-534d-41f2-869d-09ca165a26f3',
			applications: ['partner', 'bfa']
		}
	},
	responseTimes: {
		root: {
			nodes: [
				{
					data: { getModelDetails: 1.906 },
					nodes: [
						{ data: { accessToken: 0.0 } },
						{ data: { searchPortfolio: 0.214 } },
						{ data: { getPortfolioJson: 0.33 } }
					]
				}
			]
		}
	}
};

